import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { get } from '../Crypto';
import en from './en.json';
import ar from './ar.json';
import hi from './hi.json';
import zhHans from './zh-Hans.json';
import de from './de.json';
import ja from './ja.json';
import ko from './ko.json';
import tr from './tr.json';
import fr from './fr.json';
import es from './es.json';

// Language files beyond `en` start as stubs and fill in incrementally;
// fallbackLng means any missing key falls back to English rather than showing raw keys.
// `lng` is explicitly resolved (not browser-detected) so first-time visitors always start on English.
i18n
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			ar: { translation: ar },
			hi: { translation: hi },
			'zh-Hans': { translation: zhHans },
			de: { translation: de },
			ja: { translation: ja },
			ko: { translation: ko },
			tr: { translation: tr },
			fr: { translation: fr },
			es: { translation: es },
		},
		lng: get('lang') || 'en',
		fallbackLng: 'en',
		debug: false,
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
